export default __webpack_public_path__ + "86718d090328926464a992c5ed6c9ad9.png";